import { ILogisticServiceProduct } from 'types/services';
import ToolServicesEdition from '../ToolServicesEdition/ToolServicesEdition';
import { IpillsByReference } from 'types/orders';
import { NudosSelectButton } from 'components/NudosComponents';

import './ToolEditionCard.scss';

interface IToolEditionCardProps {
  productSku: string;
  products: { product: ILogisticServiceProduct; index: number }[];
  isProductSelected: boolean;
  selectedItems: Record<string, boolean>;
  onToggleProductSelection: () => void;
  onToggleSerialSelection: (index: number) => void;
}

const ToolEditionCard = ({
  productSku,
  products,
  isProductSelected,
  selectedItems,
  onToggleProductSelection,
  onToggleSerialSelection
}: IToolEditionCardProps) => {
  const product = products[0]?.product;
  const pills =
    typeof product?.product?.pills === 'string'
      ? (JSON.parse(product?.product?.pills || '{}') as IpillsByReference)
      : product?.product?.pills;

  return (
    <section className="toolEditionCard">
      <div className="toolInfo">
        <div className="toolNameContainer">
          <NudosSelectButton
            iconName="checkmark"
            handleClickButton={onToggleProductSelection}
            isButtonActive={isProductSelected}
            componentSize="xs w-8 h-8"
          />
          <div className="toolNameDetailsContainer">
            <p className="toolNameWithPills">
              <span className="toolName">{product?.product?.name}</span>
              {pills &&
                Object.values(pills).map(
                  (pill: string | null) =>
                    pill && (
                      <span key={pill} className="pill">
                        {pill}
                      </span>
                    )
                )}{' '}
            </p>
            <p className="toolSku">
              <span className="toolSkuLabel">SKU: </span>
              <span className="toolSkuValue">{productSku}</span>
            </p>
          </div>
        </div>
        {products?.map(({ product, index }) => (
          <ToolServicesEdition
            key={`serial-${index}`}
            serial={product?.product?.serial || ''}
            productIndex={index}
            isSerialSelected={selectedItems[`serial-${index}`] || false}
            onToggleSerialSelection={() => onToggleSerialSelection(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default ToolEditionCard;
